import React from "react";
import Header from "../../components/header/Header";
import { BiBriefcase } from "react-icons/bi";
import { FiMonitor } from "react-icons/fi";
import { RiUserHeartLine } from "react-icons/ri";
import Profile from "../../assets/images/about-pr.jpg";

const About = () => {
    return (
        <div className="my-12" id="about">
            <Header text={"About"} />
            <div className="py-12 flex flex-col justify-center items-center xl:flex-row xl:justify-between">
                <div>
                    <img className="about-image" src={Profile} alt="profile"></img>
                </div>
                <div className="text-light flex text-center flex-col pt-5 mx-3 2xl:mx-24">
                    <p className="text-lg">
                        I am an aspiring full stack developer, with a degree in Computer Science and Engineering. I have
                        a serious passion for Website Developement specially on UI/UX design and creating intuitive,
                        dynamic user experiences.
                    </p>
                    <div className="flex flex-col justify-center items-center sm:flex-row sm:justify-around mt-16">
                        <div className="bg-blue20 flex flex-col justify-start rounded-xl items-center w-48 pt-6 h-40 mx-6 rounded text-center my-8 lg:my-0">
                            <BiBriefcase color="#82F9A1" size={35} />
                            <p className="text-white text-xl my-2">Worked</p>
                            <span> 4+ companies</span>
                        </div>
                        <div className="bg-blue20 flex flex-col justify-start rounded-xl items-center w-48 pt-6 h-40 mx-6 rounded text-center my-8 lg:my-0">
                            <FiMonitor color="#82F9A1" size={35} />
                            <p className="text-white text-xl my-2">Completed</p>
                            <span> 10+ projects</span>
                        </div>
                        <div className="bg-blue20 flex flex-col justify-start rounded-xl items-center w-48 pt-6 h-40 mx-6 rounded text-center my-8 lg:my-0">
                            <RiUserHeartLine color="#82F9A1" size={35} />
                            <p className="text-white text-xl my-2">Experience</p>
                            <span> 3+ years</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
